import { useState, useEffect } from 'react';

export default function useModalNameValidator(e) {
  const [isSaveModalValid, setIsSaveModalValid] = useState(false);
  useEffect(() => {
    if (e) {
      let nsRegexTest2 = /^[a-zA-Z0-9 ]+$/.test(e);
      if (!nsRegexTest2) {
        setIsSaveModalValid(false);
        //       return 'error';
      } else {
        setIsSaveModalValid(true);
      }
    } else {
      setIsSaveModalValid(false);
      //   return 'error';
    }
  }, [e]);
  return isSaveModalValid;
}
